import React from 'react'
import palette from 'core-system/Themes/palette'
import SummaryBudget from './components/SummaryBudget'
import SummaryOptions from './components/SummaryOptions'
import SummaryContainerBox from 'features/Programs/Summary/components/SummaryContainerBox'
import { Flex } from 'core-system/Icons/Sidebar'

interface FlexSummaryProps {
  activeOptions: {
    flex: boolean
    gas: boolean
    transit: boolean
    parking: boolean
  }
  activeMerchantIds: {
    flex: string[]
    gas: string[]
    transit: string[]
    parking: string[]
  }
  budget: number
}

const QtfSummary = ({
  activeOptions = {
    flex: false,
    gas: false,
    transit: false,
    parking: false,
  },
  activeMerchantIds = {
    flex: [],
    gas: [],
    transit: [],
    parking: [],
  },
  budget = 0,
}: FlexSummaryProps) => {
  return (
    <SummaryContainerBox title='Fuel Allowance & Other Transportation Budget'>
      <SummaryOptions
        icon={<Flex color={palette.secondary.purple600} />}
        activeOptions={[
          {
            type: 'flex',
            activeMerchantIds: activeMerchantIds.flex,
            active: activeOptions.flex,
          },
          {
            type: 'gas',
            activeMerchantIds: activeMerchantIds.gas,
            active: activeOptions.gas,
          },
          {
            type: 'transit',
            activeMerchantIds: activeMerchantIds.transit,
            active: activeOptions.transit,
          },
          {
            type: 'parking',
            activeMerchantIds: activeMerchantIds.parking,
            active: activeOptions.parking,
          },
        ]}
      />
      <SummaryBudget
        title='Budget'
        lines={[
          {
            title: 'Monthly Budget',
            value: budget,
          },
        ]}
      />
    </SummaryContainerBox>
  )
}

export default React.memo(QtfSummary)
